import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../../settings/index';
import KioskSettingsEditPage from '@/features/kiosk/pages/KioskSettingsEditPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/edit/$id',
  component: KioskSettingsEditPage,
});
